import React, { useState, useEffect } from 'react';
import { database } from '../firebase/config';
import { ref, get } from 'firebase/database';

const WithdrawReport = () => {
  const css = `
  * { box-sizing: border-box; }
  
  .withdraw-report-container {
   
    max-width: 100%;
    margin: 0 auto;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
    background: #f5f7fa;
    min-height: 100vh;
  }
  
  .report-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    padding: 20px 27px;
    background: white;
    border-radius: 8px;
     background: var(--mobile-bg-primary);
    box-shadow: 0 1px 3px rgba(0,0,0,0.08);
  }
  
  .report-header h1 {
    margin: 0;
    color: var(--mobile-text-primary);
    font-size: 20px;
    font-weight: 700;
    letter-spacing: -0.5px;
  }
  
  .btn-refresh {
    padding: 7px 14px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    transition: all 0.2s ease;
    box-shadow: 0 2px 4px rgba(102, 126, 234, 0.2);
  }
  
  .btn-refresh:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(102, 126, 234, 0.3);
  }
  
  .loading-spinner {
    text-align: center;
    padding: 50px;
    font-size: 15px;
    color: #718096;
    background: white;
    border-radius: 8px;
  }
  
  .stats-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 10px;
    margin-bottom: 12px;
  }
  
  .stat-card {
    background: white;
    border-radius: 8px;
    padding: 14px 16px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.08);
    display: flex;
    align-items: center;
    gap: 14px;
    transition: all 0.2s ease;
    border-left: 3px solid transparent;
  }
  
  .stat-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  }
  
  .stat-card.approved {
    border-left-color: #10b981;
  }
  
  .stat-card.rejected {
    border-left-color: #ef4444;
  }
  
  .stat-icon {
    font-size: 28px;
    line-height: 1;
    filter: grayscale(0.2);
  }
  
  .stat-content {
    flex: 1;
  }
  
  .stat-content h3 {
    margin: 0 0 6px 0;
    color: #4a5568;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  
  .stat-number {
    font-size: 26px;
    font-weight: 800;
    margin: 0;
    color: #1a202c;
    line-height: 1;
  }
  
  .stat-details {
    display: flex;
    gap: 10px;
    margin-top: 8px;
    flex-wrap: wrap;
  }
  
  .stat-details span {
    font-size: 10px;
    color: #718096;
    font-weight: 600;
    background: #f7fafc;
    padding: 3px 8px;
    border-radius: 4px;
  }
  
  .report-filters {
    background: white;
    border-radius: 8px;
    padding: 14px 16px;
    margin-bottom: 12px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.08);
    display: grid;
    grid-template-columns: 2fr 1.5fr 1.5fr auto;
    gap: 10px;
    align-items: end;
  }
  
  .filter-group {
    display: flex;
    flex-direction: column;
    align-items: none;
    gap: 5px;
  }
  
  .filter-group label {
    font-size: 11px;
    font-weight: 700;
    color: #4a5568;
    text-transform: uppercase;
    letter-spacing: 0.3px;
  }
  
  .filter-select,
  .filter-input {
    padding: 7px 10px;
    border: 1.5px solid #e2e8f0;
    border-radius: 6px;
    font-size: 13px;
    color: #2d3748;
    transition: all 0.2s ease;
    background: #fafafa;
  }
  
  .filter-select:focus,
  .filter-input:focus {
    outline: none;
    border-color: #667eea;
    background: white;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  }
  
  .btn-clear-filter {
    padding: 7px 14px;
    background: #e2e8f0;
    color: #4a5568;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    transition: all 0.2s ease;
    height: 33px;
  }
  
  .btn-clear-filter:hover {
    background: #cbd5e0;
  }
  
  .export-actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    margin-bottom: 12px;
  }
  
  .btn-export {
    padding: 11px 18px;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 13px;
    font-weight: 700;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    text-transform: uppercase;
    letter-spacing: 0.3px;
  }
  
  .btn-export:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
  
  .approved-btn {
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    color: white;
    box-shadow: 0 2px 4px rgba(16, 185, 129, 0.2);
  }
  
  .approved-btn:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
  }
  
  .rejected-btn {
    background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
    color: white;
    box-shadow: 0 2px 4px rgba(239, 68, 68, 0.2);
  }
  
  .rejected-btn:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
  }
  
  .report-preview {
    background: white;
    border-radius: 8px;
    padding: 16px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.08);
  }
  
  .report-preview h2 {
    margin: 0 0 12px 0;
    color: #1a202c;
    font-size: 15px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 2px solid #e2e8f0;
    padding-bottom: 10px;
  }
  
  .no-data {
    text-align: center;
    padding: 40px;
    color: #a0aec0;
    font-size: 13px;
    font-weight: 500;
  }
  
  .table-wrapper {
    overflow-x: auto;
    border-radius: 6px;
    border: 1px solid #e2e8f0;
  }
  
  .report-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
  }
  
  .report-table thead {
    background: linear-gradient(to bottom, #f7fafc 0%, #edf2f7 100%);
    position: sticky;
    top: 0;
    z-index: 10;
  }
  
  .report-table th {
    padding: 10px 12px;
    text-align: left;
    font-weight: 700;
    color: #2d3748;
    border-bottom: 2px solid #cbd5e0;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    white-space: nowrap;
  }
  
  .report-table tbody tr {
    border-bottom: 1px solid #f1f5f9;
    transition: background-color 0.15s ease;
  }
  
  .report-table tbody tr:hover {
    background-color: #f8fafc;
  }
  
  .report-table tbody tr:last-child {
    border-bottom: none;
  }
  
  .report-table td {
    padding: 10px 12px;
    color: #4a5568;
    font-weight: 500;
  }
  
  .mode-badge {
    display: inline-block;
    padding: 3px 8px;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 700;
    background: #3b82f6;
    color: white;
    text-transform: uppercase;
    letter-spacing: 0.3px;
  }
  
  .status-badge {
    display: inline-block;
    padding: 4px 9px;
    border-radius: 5px;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.3px;
  }
  
  .status-badge.approved {
    background: #d1fae5;
    color: #065f46;
    border: 1px solid #a7f3d0;
  }
  
  .status-badge.rejected {
    background: #fee2e2;
    color: #991b1b;
    border: 1px solid #fecaca;
  }
  
  .preview-note {
    text-align: center;
    padding: 12px;
    color: #718096;
    font-size: 11px;
    font-weight: 600;
    background: #f7fafc;
    margin: 0;
    border-top: 1px solid #e2e8f0;
  }
  
  @media (max-width: 1024px) {
    .report-filters {
      grid-template-columns: 1fr 1fr;
    }
  }
  
  @media (max-width: 768px) {
    .withdraw-report-container {
      padding: 10px;
    }
    .report-header {
      flex-direction: column;
      align-items: stretch;
      gap: 10px;
    }
    .report-header h1 {
      font-size: 18px;
    }
    .stats-grid {
      grid-template-columns: 1fr;
    }
    .report-filters {
      grid-template-columns: 1fr;
      padding: 12px;
    }
    .export-actions {
      grid-template-columns: 1fr;
    }
    .report-table {
      font-size: 11px;
    }
    .report-table th,
    .report-table td {
      padding: 8px 6px;
    }
  }
  `;

  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [reportType, setReportType] = useState('approved');
  const [dateRange, setDateRange] = useState({ startDate: '', endDate: '' });
  const [stats, setStats] = useState({
    approved: { count: 0, grossAmount: 0, tdsAmount: 0, netAmount: 0 },
    rejected: { count: 0, totalAmount: 0, refundedCount: 0 }
  });

  // Format date to DD/MM/YYYY
  const formatDate = (timestamp) => {
    if (!timestamp) return 'N/A';
    const date = new Date(timestamp);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const formatTime = (timestamp) => {
    if (!timestamp) return 'N/A';
    const date = new Date(timestamp);
    return date.toLocaleTimeString('en-IN');
  };

  const fetchWithdrawRequests = async () => {
    setLoading(true);
    try {
      const requestsRef = ref(database, 'HTAMS/transactions');
      const snapshot = await get(requestsRef);

      if (snapshot.exists()) {
        const data = snapshot.val();
        const requestsArray = Object.entries(data)
          .map(([id, request]) => ({ id, ...request }))
          .filter(request => request.type === 'withdrawal'); // Filter only withdrawals

        setRequests(requestsArray);
        calculateStats(requestsArray);
      } else {
        setRequests([]);
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Failed to fetch withdrawal requests');
    } finally {
      setLoading(false);
    }
  };

  const calculateStats = (data) => {
    const approved = data.filter(r => r.status === 'approved');
    const rejected = data.filter(r => r.status === 'rejected');

    setStats({
      approved: {
        count: approved.length,
        grossAmount: approved.reduce((sum, r) => sum + parseFloat(r.grossAmount || r.amount || 0), 0),
        tdsAmount: approved.reduce((sum, r) => sum + parseFloat(r.tdsAmount || 0), 0),
        netAmount: approved.reduce((sum, r) => sum + parseFloat(r.netAmount || r.amount || 0), 0),
      },
      rejected: {
        count: rejected.length,
        totalAmount: rejected.reduce((sum, r) => sum + parseFloat(r.amount || 0), 0),
        refundedCount: rejected.filter(r => r.refundedToWallet).length,
      }
    });
  };

  // Filter and sort requests
  const getFilteredRequests = () => {
    // Filter by status (approved or rejected)
    let filtered = requests.filter(r => r.status === reportType);

    // Apply date range filter if both dates are selected
    if (dateRange.startDate && dateRange.endDate) {
      const start = new Date(dateRange.startDate).setHours(0, 0, 0, 0);
      const end = new Date(dateRange.endDate).setHours(23, 59, 59, 999);

      filtered = filtered.filter(r => {
        const requestDate = new Date(r.requestedAt).getTime();
        return requestDate >= start && requestDate <= end;
      });
    }

    // Sort by requestedAt timestamp: newest first (descending order)
    filtered.sort((a, b) => {
      const dateA = new Date(a.requestedAt).getTime();
      const dateB = new Date(b.requestedAt).getTime();
      return dateB - dateA; // Newest first
    });

    return filtered;
  };

  const exportApprovedReport = () => {
    const approvedRequests = getFilteredRequests();
    if (approvedRequests.length === 0) {
      alert('No approved requests found for the selected date range');
      return;
    }

    const headers = [
      'Transaction ID', 'User Name', 'Email', 'Mobile',
      'Gross Amount', 'TDS %', 'TDS Amount', 'Net Amount',
      'Payment Mode', 'Status', 'Requested Date', 'Requested Time',
      'Approved Date', 'Approved Time', 'Approved By',
      'Account Holder Name', 'Account Number', 'Bank Name',
      'IFSC Code', 'UPI ID', 'UPI Name'
    ];

    const csvContent = [
      headers.join(','),
      ...approvedRequests.map(request => {
        const bankDetails = request.mode === 'bank' ? request.bankDetails : {};
        const upiDetails = request.mode === 'upi' ? request.upiDetails : {};
        return [
          `'${request.id}`,
          `"${request.userDetails?.name || 'N/A'}"`,
          request.userDetails?.email || 'N/A',
          request.userDetails?.mobile || 'N/A',
          request.grossAmount || request.amount,
          request.tdsPercentage || 0,
          request.tdsAmount || 0,
          request.netAmount || request.amount,
          request.mode?.toUpperCase() || 'N/A',
          request.status?.toUpperCase(),
          formatDate(request.requestedAt),
          formatTime(request.requestedAt),
          request.approvedAt ? formatDate(request.approvedAt) : 'N/A',
          request.approvedAt ? formatTime(request.approvedAt) : 'N/A',
          request.approvedBy || 'N/A',
          `"${bankDetails.accountHolderName || 'N/A'}"`,
          bankDetails.accountNumber || 'N/A',
          `"${bankDetails.bankName || 'N/A'}"`,
          bankDetails.ifscCode || 'N/A',
          upiDetails.upiId || 'N/A',
          `"${upiDetails.upiName || 'N/A'}"`
        ].join(',');
      })
    ].join('\n');

    const totalNet = approvedRequests.reduce((sum, r) => sum + parseFloat(r.netAmount || r.amount), 0);

    downloadCSV(csvContent, 'approved_requests_report');
    alert(`Approved Report Exported!\n\nTotal: ${approvedRequests.length} requests\nNet Amount: ₹${totalNet.toLocaleString('en-IN')}`);
  };

  const exportRejectedReport = () => {
    const rejectedRequests = getFilteredRequests();
    if (rejectedRequests.length === 0) {
      alert('No rejected requests found for the selected date range');
      return;
    }

    const headers = [
      'Transaction ID', 'User Name', 'Email', 'Mobile',
      'Amount', 'Payment Mode', 'Status', 'Requested Date',
      'Requested Time', 'Rejected Date', 'Rejected Time',
      'Rejected By', 'Rejection Reason', 'Refunded to Wallet'
    ];

    const csvContent = [
      headers.join(','),
      ...rejectedRequests.map(request => [
        `'${request.id}`,
        `"${request.userDetails?.name || 'N/A'}"`,
        request.userDetails?.email || 'N/A',
        request.userDetails?.mobile || 'N/A',
        request.amount,
        request.mode?.toUpperCase() || 'N/A',
        request.status?.toUpperCase(),
        formatDate(request.requestedAt),
        formatTime(request.requestedAt),
        request.rejectedAt ? formatDate(request.rejectedAt) : 'N/A',
        request.rejectedAt ? formatTime(request.rejectedAt) : 'N/A',
        request.rejectedBy || 'N/A',
        `"${request.rejectionReason || 'No reason provided'}"`,
        request.refundedToWallet ? 'Yes' : 'No'
      ].join(','))
    ].join('\n');

    const totalAmount = rejectedRequests.reduce((sum, r) => sum + parseFloat(r.amount), 0);

    downloadCSV(csvContent, 'rejected_requests_report');
    alert(`Rejected Report Exported!\n\nTotal: ${rejectedRequests.length} requests\nAmount: ₹${totalAmount.toLocaleString('en-IN')}`);
  };

  const downloadCSV = (content, filename) => {
    const blob = new Blob(['\uFEFF' + content], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${filename}_${Date.now()}.csv`;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  useEffect(() => {
    fetchWithdrawRequests();
    // eslint-disable-next-line
  }, []);

  const filteredRequests = getFilteredRequests();

  return (
    <div className="withdraw-report-container">
      <style>{css}</style>

      <div className="report-header">
        <h1>📊 Withdrawal Reports</h1>
        <button className="btn-refresh" onClick={fetchWithdrawRequests}>
          🔄 Refresh
        </button>
      </div>

      {loading ? (
        <div className="loading-spinner">Loading reports...</div>
      ) : (
        <>
          <div className="stats-grid">
            <div className="stat-card approved">
              {/* <div className="stat-icon">✅</div> */}
              <div className="stat-content">
                <h3>Approved Requests</h3>
                <p className="stat-number">{stats.approved.count}</p>
                <div className="stat-details">
                  <span>Gross: ₹{stats.approved.grossAmount.toLocaleString('en-IN')}</span>
                  <span>TDS: ₹{stats.approved.tdsAmount.toLocaleString('en-IN')}</span>
                  <span>Net: ₹{stats.approved.netAmount.toLocaleString('en-IN')}</span>
                </div>
              </div>
            </div>

            <div className="stat-card rejected">
              {/* <div className="stat-icon">❌</div> */}
              <div className="stat-content">
                <h3>Rejected Requests</h3>
                <p className="stat-number">{stats.rejected.count}</p>
                <div className="stat-details">
                  <span>Amount: ₹{stats.rejected.totalAmount.toLocaleString('en-IN')}</span>
                  <span>Refunded: {stats.rejected.refundedCount}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="report-filters">
            <div className="filter-group">
              <label>Report Type:</label>
              <select
                value={reportType}
                onChange={(e) => setReportType(e.target.value)}
                className="filter-select"
              >
                <option value="approved">Approved Requests</option>
                <option value="rejected">Rejected Requests</option>
              </select>
            </div>

            <div className="filter-group">
              <label>Start Date:</label>
              <input
                type="date"
                value={dateRange.startDate}
                onChange={(e) => setDateRange({ ...dateRange, startDate: e.target.value })}
                className="filter-input"
              />
            </div>

            <div className="filter-group">
              <label>End Date:</label>
              <input
                type="date"
                value={dateRange.endDate}
                onChange={(e) => setDateRange({ ...dateRange, endDate: e.target.value })}
                className="filter-input"
              />
            </div>

            <button
              className="btn-clear-filter"
              onClick={() => setDateRange({ startDate: '', endDate: '' })}
            >
              Clear Dates
            </button>
          </div>

          <div className="export-actions">
            <button
              className="btn-export approved-btn"
              onClick={exportApprovedReport}
              disabled={reportType !== 'approved'}
            >
              📥 Export Approved ({filteredRequests.length})
            </button>

            <button
              className="btn-export rejected-btn"
              onClick={exportRejectedReport}
              disabled={reportType !== 'rejected'}
            >
              📥 Export Rejected ({filteredRequests.length})
            </button>
          </div>

          <div className="report-preview">
            <h2>Preview: {reportType === 'approved' ? 'Approved' : 'Rejected'} ({filteredRequests.length})</h2>

            {filteredRequests.length === 0 ? (
              <p className="no-data">No requests found for the selected criteria</p>
            ) : (
              <div className="table-wrapper">
                <table className="report-table">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>User Name</th>
                      <th>Mobile</th>
                      <th>Amount</th>
                      <th>Mode</th>
                      <th>Date</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredRequests.slice(0, 10).map(request => (
                      <tr key={request.id}>
                        <td>{request.id.substring(0, 8)}...</td>
                        <td>{request.userDetails?.name || 'N/A'}</td>
                        <td>{request.userDetails?.mobile || 'N/A'}</td>
                        <td>₹{(request.netAmount || request.amount || 0).toLocaleString('en-IN')}</td>
                        <td><span className="mode-badge">{request.mode?.toUpperCase()}</span></td>
                        <td>{formatDate(request.requestedAt)}</td>
                        <td><span className={`status-badge ${request.status}`}>{request.status?.toUpperCase()}</span></td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                {filteredRequests.length > 10 && (
                  <p className="preview-note">Showing 10 of {filteredRequests.length} requests. Export to see all.</p>
                )}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default WithdrawReport;
